import CommonError from '@/common/utils/errors/CommonError';

export default class CancellationError extends CommonError {
  body?: any;

  constructor(body?: any) {
    super('Cancel action', 'Cancel action');

    this.body = body;
  }
}
